import { signal } from '@preact/signals';
import {
  clearSession,
  isAuthenticated,
  login as apiLogin,
  logout as apiLogout,
  onUnauthorized,
} from '@/api';

export const isAuthed = signal(isAuthenticated());

export async function performLogin(email, password) {
  const data = await apiLogin(email, password);
  isAuthed.value = true;
  return data;
}

export function performLogout() {
  apiLogout();
  isAuthed.value = false;
}

export function syncAuthFromToken() {
  isAuthed.value = isAuthenticated();
}

/**
 * Принудительно сбросить сессию (например при 401).
 */
export function forceLogout() {
  clearSession();
  isAuthed.value = false;
}

// Сессия окончательно недействительна (access истёк и refresh не помог) —
// показываем экран входа вместо сырой ошибки «Unauthenticated.».
onUnauthorized(forceLogout);
